import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4 } from 'approot/shared/styles/colours.style';
import {
  spacing12,
  spacing16,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { Box } from 'approot/shared/styles/box.style';

export const LessonMaterialsCalculatorTableStyled = styled.table`
  width: 100%;
  table-layout: fixed;
  border-bottom: 1px solid ${grey4};
  margin: ${rem(spacing12)} 0 ${rem(spacing8)};

  tbody tr:first-child {
    border-top: 1px solid ${grey4};
  }

  tr:not(:last-child) {
    border-bottom: 1px solid ${grey4};
  }

  td {
    padding: ${rem(spacing8)};
    width: 50%;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
`;

export const LessonMaterialsCalculatorContainer = styled(Box)`
  padding-top: ${rem(spacing16)};
  max-width: ${rem(600)};
`;
